
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },

        {
  hid: 'description',
  name: 'description',
  content: 'Explore the best of North Goa with unforgettable sightseeing experiences. From stunning beaches to historical landmarks, discover everything this vibrant region has to offer.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover the top sightseeing spots in North Goa. From beautiful beaches to historic sites, explore the vibrant culture and scenic landscapes of this amazing region.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Enjoy the best of North Goa sightseeing. Visit stunning beaches, historic landmarks, and vibrant local spots for a truly unforgettable experience.',
},



        {
          hid: 'keywords',
          name: 'keywords',
          content: 'north goa tourist places, north goa tourist places list, top 5 tourist places in north goa, top 10 tourist places in north goa, north goa places to visit in one day, places to visi in north goa for couples, north goa places to visit with friends, places to visit in north goa other than beaches',
        },
      
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Stunning Destinations",
      text: "Discover breathtaking views and hidden gems with the best sightseeing spots in Goa!",
    },
    {
      title: "Fun for Everyone",
      text: "Whether you're an adventure lover or prefer a relaxed tour, there's something for everyone!",
    },
    {
      title: "Local Guides",
      text: "Our experienced guides will take you to the top attractions and share fascinating insights.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect sightseeing tour effortlessly through the Goa App at great rates!",
    },
  ],

    
      title: 'North Goa Tourist Places - North Goa Tourist Places List',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-04-01T13%3A33%3A53.913Zbaga-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=M8HJ8S9nQWb5zIjG9MzfcFM9TGvcJVwhGWRxd8kGDMEgK2ja9kR82ZkEl9dS2DEzvPzTl%2BUpEXaM%2Fehii%2F3FPGMbhZxbBwdkwgiWu%2FkJPa0NffbUzelA2qr1CSmC92yyGAh5EHUQrOzFYgY5bUTQblsv8wr6wxVqnKsY5%2FX4UmsmmjSnWAoPdJAQZpH3PNFjmYN5gDDIOsCtuxa7bYrCKKcPvaZL%2BvnMRD1AGbZ%2BxrBU6CmEt2cfkr5wEuAtEdHXZvUmzN5Dx%2BjAXVZ06pqTLaKJNZTAllE35d%2FMSmIgukKD2Eqdgu%2FakvWueKcuKBS%2BVkjmzhKFMhWkB0vzyVEZLw%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-04-01T13%3A33%3A53.913Zbaga-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=M8HJ8S9nQWb5zIjG9MzfcFM9TGvcJVwhGWRxd8kGDMEgK2ja9kR82ZkEl9dS2DEzvPzTl%2BUpEXaM%2Fehii%2F3FPGMbhZxbBwdkwgiWu%2FkJPa0NffbUzelA2qr1CSmC92yyGAh5EHUQrOzFYgY5bUTQblsv8wr6wxVqnKsY5%2FX4UmsmmjSnWAoPdJAQZpH3PNFjmYN5gDDIOsCtuxa7bYrCKKcPvaZL%2BvnMRD1AGbZ%2BxrBU6CmEt2cfkr5wEuAtEdHXZvUmzN5Dx%2BjAXVZ06pqTLaKJNZTAllE35d%2FMSmIgukKD2Eqdgu%2FakvWueKcuKBS%2BVkjmzhKFMhWkB0vzyVEZLw%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-04-01T13%3A33%3A53.913Zbaga-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=M8HJ8S9nQWb5zIjG9MzfcFM9TGvcJVwhGWRxd8kGDMEgK2ja9kR82ZkEl9dS2DEzvPzTl%2BUpEXaM%2Fehii%2F3FPGMbhZxbBwdkwgiWu%2FkJPa0NffbUzelA2qr1CSmC92yyGAh5EHUQrOzFYgY5bUTQblsv8wr6wxVqnKsY5%2FX4UmsmmjSnWAoPdJAQZpH3PNFjmYN5gDDIOsCtuxa7bYrCKKcPvaZL%2BvnMRD1AGbZ%2BxrBU6CmEt2cfkr5wEuAtEdHXZvUmzN5Dx%2BjAXVZ06pqTLaKJNZTAllE35d%2FMSmIgukKD2Eqdgu%2FakvWueKcuKBS%2BVkjmzhKFMhWkB0vzyVEZLw%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/north-goa-tourist-places`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/north-goa-tourist-places`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-04-01T13%3A33%3A53.913Zbaga-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=M8HJ8S9nQWb5zIjG9MzfcFM9TGvcJVwhGWRxd8kGDMEgK2ja9kR82ZkEl9dS2DEzvPzTl%2BUpEXaM%2Fehii%2F3FPGMbhZxbBwdkwgiWu%2FkJPa0NffbUzelA2qr1CSmC92yyGAh5EHUQrOzFYgY5bUTQblsv8wr6wxVqnKsY5%2FX4UmsmmjSnWAoPdJAQZpH3PNFjmYN5gDDIOsCtuxa7bYrCKKcPvaZL%2BvnMRD1AGbZ%2BxrBU6CmEt2cfkr5wEuAtEdHXZvUmzN5Dx%2BjAXVZ06pqTLaKJNZTAllE35d%2FMSmIgukKD2Eqdgu%2FakvWueKcuKBS%2BVkjmzhKFMhWkB0vzyVEZLw%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-04-01T13%3A33%3A53.913Zbaga-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=M8HJ8S9nQWb5zIjG9MzfcFM9TGvcJVwhGWRxd8kGDMEgK2ja9kR82ZkEl9dS2DEzvPzTl%2BUpEXaM%2Fehii%2F3FPGMbhZxbBwdkwgiWu%2FkJPa0NffbUzelA2qr1CSmC92yyGAh5EHUQrOzFYgY5bUTQblsv8wr6wxVqnKsY5%2FX4UmsmmjSnWAoPdJAQZpH3PNFjmYN5gDDIOsCtuxa7bYrCKKcPvaZL%2BvnMRD1AGbZ%2BxrBU6CmEt2cfkr5wEuAtEdHXZvUmzN5Dx%2BjAXVZ06pqTLaKJNZTAllE35d%2FMSmIgukKD2Eqdgu%2FakvWueKcuKBS%2BVkjmzhKFMhWkB0vzyVEZLw%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/north-goa-tourist-places`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "North Goa Tourist Places - Book @ ₹399 Flat 33% Off",
  "description": "Experience the best sightseeing in North Goa, where stunning landscapes, vibrant culture, and iconic landmarks come together for an unforgettable journey filled with picturesque moments.",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-04-01T13%3A33%3A53.913Zbaga-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=M8HJ8S9nQWb5zIjG9MzfcFM9TGvcJVwhGWRxd8kGDMEgK2ja9kR82ZkEl9dS2DEzvPzTl%2BUpEXaM%2Fehii%2F3FPGMbhZxbBwdkwgiWu%2FkJPa0NffbUzelA2qr1CSmC92yyGAh5EHUQrOzFYgY5bUTQblsv8wr6wxVqnKsY5%2FX4UmsmmjSnWAoPdJAQZpH3PNFjmYN5gDDIOsCtuxa7bYrCKKcPvaZL%2BvnMRD1AGbZ%2BxrBU6CmEt2cfkr5wEuAtEdHXZvUmzN5Dx%2BjAXVZ06pqTLaKJNZTAllE35d%2FMSmIgukKD2Eqdgu%2FakvWueKcuKBS%2BVkjmzhKFMhWkB0vzyVEZLw%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "399",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/north-goa-tourist-places",
        "url": "https://www.goa.app/north-goa-tourist-places",
        "name": "North Goa Tourist Places",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-04-01T13%3A33%3A53.913Zbaga-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=M8HJ8S9nQWb5zIjG9MzfcFM9TGvcJVwhGWRxd8kGDMEgK2ja9kR82ZkEl9dS2DEzvPzTl%2BUpEXaM%2Fehii%2F3FPGMbhZxbBwdkwgiWu%2FkJPa0NffbUzelA2qr1CSmC92yyGAh5EHUQrOzFYgY5bUTQblsv8wr6wxVqnKsY5%2FX4UmsmmjSnWAoPdJAQZpH3PNFjmYN5gDDIOsCtuxa7bYrCKKcPvaZL%2BvnMRD1AGbZ%2BxrBU6CmEt2cfkr5wEuAtEdHXZvUmzN5Dx%2BjAXVZ06pqTLaKJNZTAllE35d%2FMSmIgukKD2Eqdgu%2FakvWueKcuKBS%2BVkjmzhKFMhWkB0vzyVEZLw%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-04-01T13%3A33%3A53.913Zbaga-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=M8HJ8S9nQWb5zIjG9MzfcFM9TGvcJVwhGWRxd8kGDMEgK2ja9kR82ZkEl9dS2DEzvPzTl%2BUpEXaM%2Fehii%2F3FPGMbhZxbBwdkwgiWu%2FkJPa0NffbUzelA2qr1CSmC92yyGAh5EHUQrOzFYgY5bUTQblsv8wr6wxVqnKsY5%2FX4UmsmmjSnWAoPdJAQZpH3PNFjmYN5gDDIOsCtuxa7bYrCKKcPvaZL%2BvnMRD1AGbZ%2BxrBU6CmEt2cfkr5wEuAtEdHXZvUmzN5Dx%2BjAXVZ06pqTLaKJNZTAllE35d%2FMSmIgukKD2Eqdgu%2FakvWueKcuKBS%2BVkjmzhKFMhWkB0vzyVEZLw%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-04-01T13%3A33%3A53.913Zbaga-beach-2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=M8HJ8S9nQWb5zIjG9MzfcFM9TGvcJVwhGWRxd8kGDMEgK2ja9kR82ZkEl9dS2DEzvPzTl%2BUpEXaM%2Fehii%2F3FPGMbhZxbBwdkwgiWu%2FkJPa0NffbUzelA2qr1CSmC92yyGAh5EHUQrOzFYgY5bUTQblsv8wr6wxVqnKsY5%2FX4UmsmmjSnWAoPdJAQZpH3PNFjmYN5gDDIOsCtuxa7bYrCKKcPvaZL%2BvnMRD1AGbZ%2BxrBU6CmEt2cfkr5wEuAtEdHXZvUmzN5Dx%2BjAXVZ06pqTLaKJNZTAllE35d%2FMSmIgukKD2Eqdgu%2FakvWueKcuKBS%2BVkjmzhKFMhWkB0vzyVEZLw%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "North Goa sightseeing Tour offers breathtaking views of stunning beaches, vibrant culture, and scenic landscapes. It’s an ideal destination for travelers looking to explore beautiful sunsets, historic sites like Aguada Fort, and lush greenery, creating unforgettable memories along the way.",
        "breadcrumb": {
            "@id": "https://www.goa.app/north-goa-tourist-places/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/north-goa-tourist-places"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
      "@type": "Question",
      "name": "What are the best sightseeing spots in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Some of the best sightseeing spots in North Goa include Calangute Beach, Baga Beach, Aguada Fort, and the serene Sinquerim Beach."
      }
    },
    {
      "@type": "Question",
      "name": "What types of tours are available for North Goa sightseeing?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "In North Goa, you can find various sightseeing tours, including full-day trips, bus tours, and private car hire options."
      }
    },
    {
      "@type": "Question",
      "name": "How much does a North Goa sightseeing tour cost?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "North Goa sightseeing tours typically start from ₹399 for bus tours and ₹2,499 for car rentals, depending on the package chosen."
      }
    },
    {
      "@type": "Question",
      "name": "Can I customize my North Goa sightseeing tour?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, many tour operators in North Goa offer customizable packages tailored to your preferences and interests."
      }
    },
    {
      "@type": "Question",
      "name": "What is the best time for sightseeing in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The best time for sightseeing in North Goa is during the cooler months from November to February, ensuring pleasant weather."
      }
    },
    {
      "@type": "Question",
      "name": "Are there any restrictions on visiting certain sightseeing spots?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, some sightseeing locations in North Goa may have entry restrictions or require permits, especially during peak seasons."
      }
    },
    {
      "@type": "Question",
      "name": "Do sightseeing packages include a guide?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most sightseeing packages in North Goa include a guide who can provide insights about the locations and culture."
      }
    },
    {
      "@type": "Question",
      "name": "Can I choose my sightseeing locations?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely! Many tour operators will collaborate with you to select locations that match your interests for the tour."
      }
    },
    {
      "@type": "Question",
      "name": "What should I wear for a sightseeing tour in North Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It's recommended to wear comfortable clothing and footwear, as you may be exploring various outdoor locations throughout the day."
      }
    },
    {
      "@type": "Question",
      "name": "How do I book a North Goa sightseeing tour?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can book a North Goa sightseeing tour through various travel agencies or online platforms specializing in Goan tours and activities."
      }
    }
        ]
      }
    ]
  };
},


};



  